import React from 'react';
import { Outlet } from 'react-router-dom';
import { MenuPromoBackground } from '../../../widgets/menu-promo-background';
import { Screen } from './PromoLayout.styles';

/** 투표·결과 공통 레이아웃 — hero 배경은 1회 마운트 후 유지 */
export function PromoLayout() {
  return (
    <Screen>
      <MenuPromoBackground />
      <Outlet />
    </Screen>
  );
}
